import applyBulkItemActionOperation from 'owa-service/lib/operation/applyBulkItemActionOperation';
import { getJsonRequestHeader } from 'owa-service/lib/Utils';
import applyBulkItemActionRequest from 'owa-service/lib/factory/applyBulkItemActionRequest';
import { isMailFeatureEnabled } from 'owa-mail-feature-flags';
/**
 * Always delete conversation Service
 * @param sourceFolderId the source folderId
 * @param emailAddresses emailaddresses
 * @param itemPropertytoUpdate the item property to update
 * @return the ApplyBulkItemActionResponse
 */
export default function alwaysDeleteConversationsService(emailAddresses, destinationFolderId, sourceFolderId, keepNType, keepNCount, customData) {
    var requestBody = applyBulkItemActionRequest({
        ActionType: 0 /* Move */,
        DestinationFolderId: { Id: destinationFolderId },
        EmailAddresses: emailAddresses,
        SourceFolderId: { Id: sourceFolderId },
        CountType: keepNType,
        KeepNCount: keepNCount,
        BulkActionRequest: isMailFeatureEnabled('tri-bulkActionNotification') &&
            isMailFeatureEnabled('tri-sweepBulkAction'),
        BulkActionCustomData: customData && JSON.stringify(customData),
    });
    return applyBulkItemActionOperation({
        Header: getJsonRequestHeader(),
        Body: requestBody,
    }).then(function (response) {
        return response.Body.ResponseMessages.Items[0];
    });
}
//# sourceMappingURL=alwaysDeleteConversationsService.js.map